export * from './UiMenuDots8VIcon';
export * from './UiMenuDots8VIcon16Light';
export * from './UiMenuDots8VIcon16Regular';
export * from './UiMenuDots8VIcon16Solid';
export * from './UiMenuDots8VIcon20Light';
export * from './UiMenuDots8VIcon20Regular';
export * from './UiMenuDots8VIcon20Solid';
export * from './UiMenuDots8VIcon24Regular';
export * from './UiMenuDots8VIcon24Solid';
export * from './UiMenuDots8VIcon32Regular';
export * from './UiMenuDots8VIcon64Regular';
